/* @flow */

import * as React from 'react';
import ReactDOM from 'react-dom';
import { TweenMax, TimelineMax } from 'gsap';

type Props = {
  children: any,
  animation: HTMLElement => TweenMax | TimelineMax,
  component?: any,
  forceNoChange?: boolean,
  value: any,
};

type State = {
  isAnimating: boolean,
};

class AnimateOnChange extends React.Component<Props, State> {
  props: Props;
  state: State = {
    isAnimating: false, // eslint-disable-line react/no-unused-state
  };

  static defaultProps = {
    component: 'span',
    forceNoChange: false,
  };

  animationInstance: TweenMax; // eslint-disable-line react/sort-comp
  node: HTMLElement;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { value } = this.props;
    if (nextProps.forceNoChange || value === nextProps.value) {
      return;
    }

    this.setState({
      isAnimating: true, // eslint-disable-line react/no-unused-state
    });

    if (this.animationInstance) {
      this.animationInstance.kill();
    }
    this.animationInstance = nextProps.animation(this.node).eventCallback('onStart', () =>
      this.setState({
        isAnimating: false, // eslint-disable-line react/no-unused-state
      }));
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return !nextState.isAnimating;
  }

  componentWillUnmount() {
    if (this.animationInstance) {
      this.animationInstance.kill();
    }
  }

  setRef = (node: HTMLElement) => {
    this.node = ReactDOM.findDOMNode(node);
  };

  render() {
    const { component: Component, children } = this.props;
    return <Component ref={this.setRef}>{children}</Component>;
  }
}

export default AnimateOnChange;
